import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=406c1a3b&scoped=true&lang=pug"
import script from "./ServerError.vue?vue&type=script&lang=js"
export * from "./ServerError.vue?vue&type=script&lang=js"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=406c1a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406c1a3b",
  null
  
)

export default component.exports